<div class="imgcap">
  <img src="{{data.srcimg}}" />
</div>
